module.exports = __webpack_public_path__ + "img/logo-white.1b41f030.png";